import $ from "jquery";

$(document).on("click", ".js-reviews-btn.active", function () {
  let reviews = $(".js-reviews"),
    headerHeight = $(".top-nav__panel").height(),
    finalOffset = reviews.offset().top - headerHeight;
  $("html, body").animate({ scrollTop: finalOffset }, 250);
});
